module.exports = __webpack_public_path__ + "img/logos.3bf197d2.png";